import React from 'react';

const FormAddressSearchDetail = ({ handleChange, addressComponentData }) => {
  const getComponentDataValue = type => {
    const [result] = addressComponentData.filter(component => component.types[0] === type);

    if (!result) return;

    return result.long_name;
  };

  if (addressComponentData.length < 1) return <></>;

  return (
    <div className="container pt-3 pb-4 mt-3 rounded bg-soft" id="addressDetail">
      <div className="row mb-2">
        <div className="col">
          <input
            name="address.unit_no"
            aria-label="unit number"
            className="form-control"
            placeholder="Unit no."
            value={getComponentDataValue('subpremise')}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <input
            className="form-control"
            aria-label="street number"
            placeholder="Street Number"
            value={getComponentDataValue('street_number')}
            disabled
          />
        </div>
      </div>
      <div className="row mb-2">
        <div className="col">
          <input
            className="form-control"
            aria-label="street name"
            placeholder="Street Name"
            value={getComponentDataValue('route')}
            disabled
          />
        </div>
      </div>
      <div className="row mb-2">
        <div className="col">
          <input
            className="form-control"
            aria-label="city"
            placeholder="City"
            value={getComponentDataValue('locality')}
            disabled
          />
        </div>
      </div>
      <div className="row mb-2">
        <div className="col">
          <input
            className="form-control"
            aria-label="state"
            placeholder="State"
            value={getComponentDataValue('administrative_area_level_1')}
            disabled
          />
        </div>
        <div className="col">
          <input
            className="form-control"
            aria-label="post code"
            placeholder="Post Code"
            value={getComponentDataValue('postal_code')}
            disabled
          />
        </div>
      </div>
    </div>
  );
};

export default FormAddressSearchDetail;
